'use client'
import {
  FirstAvailablePlan_default
} from "./chunk-32AVF4GI.mjs";
import {
  ExpandableBenfitsList_default
} from "./chunk-6RPHG7BM.mjs";
import {
  calculateDateToBuy
} from "./chunk-BEOLAJXM.mjs";
import {
  saveSubscriptionIntent
} from "./chunk-PQ5D4ZZX.mjs";
import {
  useSubscriptionBenefits
} from "./chunk-2NOUJXRY.mjs";
import {
  useSubscription
} from "./chunk-NAUELPNF.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/checks/priority/Check.tsx
import { useEffect as useEffect2, useMemo, useRef as useRef2, useState as useState3 } from "react";
import { Carousel, Spinner, Typography as Typography2 } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { parseDate } from "@wbk/utils";
import { useCountDown as useCountDown2 } from "@wbk/hooks";
import { useTranslation as useTranslation3 } from "@wbk/config";

// src/components/checks/priority/Notice.tsx
import { useEffect, useState } from "react";
import { Button, Modal } from "@wbk/ui";
import { useAuth } from "@wbk/auth";
import { useTranslation } from "@wbk/config";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var PurchasePriorityNotice = () => {
  var _a, _b;
  const { t } = useTranslation("subscription_common");
  const [show, setShow] = useState(false);
  const { user } = useAuth();
  const plan = (_b = (_a = user == null ? void 0 : user.user_subscriptions) == null ? void 0 : _a[0]) == null ? void 0 : _b.plan;
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const priority = searchParams.get("priority");
    const showModal = priority === "1";
    if (showModal) {
      setShow(true);
    }
  }, []);
  return /* @__PURE__ */ jsx(
    Modal,
    {
      closeButton: true,
      ignoreHistory: true,
      show,
      size: "lg",
      className: "pb-24",
      contentClassName: "max-w-[95%] xs:max-w-lg",
      onClose: () => {
        setShow(false);
      },
      body: () => {
        var _a2;
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs("div", { className: "p-4 md:p-6", children: [
            /* @__PURE__ */ jsx("h2", { className: "text-2xl font-semibold", children: t("subscription_common:purchase_priority.congradulations_title", {
              name: ((_a2 = plan == null ? void 0 : plan.plan_group) == null ? void 0 : _a2.name) || ""
            }) }),
            /* @__PURE__ */ jsx("p", { className: "text-text-secondary", children: t("subscription_common:purchase_priority.congradulations_subtitle", {
              email: (user == null ? void 0 : user.email) || ""
            }) })
          ] }),
          ((plan == null ? void 0 : plan.mobile_banner) || (plan == null ? void 0 : plan.banner)) && /* @__PURE__ */ jsx(
            "img",
            {
              src: (plan == null ? void 0 : plan.mobile_banner) || (plan == null ? void 0 : plan.banner),
              alt: `${plan == null ? void 0 : plan.name} banner`,
              height: 240,
              width: 240,
              className: "mx-auto max-h-60 w-auto"
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "space-y-4 p-4 md:p-6", children: [
            /* @__PURE__ */ jsx("p", { className: "text-xl font-semibold", children: t("subscription_common:explore_your_benefits") }),
            /* @__PURE__ */ jsx(ExpandableBenfitsList_default, { limit: 4, benefits: (plan == null ? void 0 : plan.benefits) || [], riyadhSeason: true })
          ] })
        ] });
      },
      stickyFooter: () => /* @__PURE__ */ jsx("div", { className: "flex justify-end gap-4 p-4", children: /* @__PURE__ */ jsx(
        Button,
        {
          className: "shrink-0",
          onClick: () => {
            setShow(false);
          },
          children: t("subscription_common:purchase_priority.book_tickets")
        }
      ) })
    }
  );
};
var Notice_default = PurchasePriorityNotice;

// src/components/checks/priority/Card.tsx
import { useRef, useState as useState2 } from "react";
import { BottomSheet, Button as Button2, ImageWithFallback, Modal as Modal2, Paper, Typography } from "@wbk/ui";
import { Link, useRouter, useTranslation as useTranslation2 } from "@wbk/config";
import { useCountDown, useDeviceDetect } from "@wbk/hooks";
import { CurrencyPriceLabel } from "@wbk/currency";
import { SubscriptionIcon } from "@wbk/svg";
import { useAnalytics } from "@wbk/analytics";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var PriorityPlanCard = ({ planInfo, event }) => {
  const { locale, push } = useRouter();
  const { trackEvent } = useAnalytics();
  const { t } = useTranslation2("subscription_common");
  const NOW = useRef(Date.now() / 1e3);
  const { isTimeUp, timer } = useCountDown({
    id: planInfo.subscription_plan_group_id,
    initialSeconds: planInfo.dateToBuy.getTime() / 1e3 - NOW.current
  });
  const { isMobile } = useDeviceDetect();
  const [plan, setPlan] = useState2();
  if (!planInfo) {
    return /* @__PURE__ */ jsx2("div", { className: "space-y-4 pb-20", children: /* @__PURE__ */ jsx2("p", { className: "text-text-secondary py-6 text-center", children: t("subscription_common:no_subscriptions") }) });
  }
  const saveIntent = () => {
    saveSubscriptionIntent({ name: "purchase_priority" });
  };
  const trackUpgradeEvent = () => {
    trackEvent({
      event: "clicked_on_upgrade_continue_purchase_priority",
      data: {
        event: event.slug,
        plan: planInfo.subscription_name,
        billing_type: plan == null ? void 0 : plan.payment_terms
      }
    });
  };
  return /* @__PURE__ */ jsxs2(Paper, { className: "space-y-4 overflow-hidden", children: [
    isTimeUp ? /* @__PURE__ */ jsx2(
      Typography,
      {
        variant: "body-S",
        color: "success",
        className: "bg-body-level-1 -mx-4 -mt-4 px-4 py-2",
        children: t("subscription_common:tickets_available_now")
      }
    ) : /* @__PURE__ */ jsxs2(
      Typography,
      {
        variant: "body-S",
        color: "text-secondary",
        className: "bg-body-level-1 -mx-4 -mt-4 px-4 py-2",
        children: [
          t("subscription_common:tickets_available_in"),
          " ",
          /* @__PURE__ */ jsxs2("strong", { className: "text-text", children: [
            timer.days ? `${timer.days} ${t("subscription_common:days")} : ` : "",
            `${timer.hours} ${t("subscription_common:hrs")} : `,
            `${timer.minutes} ${t("subscription_common:mins")} : `,
            `${timer.seconds} ${t("subscription_common:secs")}`
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs2("div", { className: "flex items-center justify-between gap-3", children: [
      /* @__PURE__ */ jsx2(
        ImageWithFallback,
        {
          src: planInfo.subscription_icon,
          alt: planInfo.subscription_name,
          width: 32,
          height: 32,
          className: "shrink-0"
        }
      ),
      /* @__PURE__ */ jsxs2("div", { className: "flex-1", children: [
        /* @__PURE__ */ jsx2(Typography, { variant: "heading-XS", children: planInfo.subscription_name }),
        /* @__PURE__ */ jsxs2("div", { className: "flex items-baseline gap-1 text-sm", children: [
          /* @__PURE__ */ jsx2(
            CurrencyPriceLabel,
            {
              originalPrice: (planInfo == null ? void 0 : planInfo.subscription_plan_price) + (planInfo == null ? void 0 : planInfo.vat),
              currency: planInfo.currency
            }
          ),
          /* @__PURE__ */ jsx2("span", { className: "text-text-secondary", children: `/ ${planInfo == null ? void 0 : planInfo.payment_terms}` })
        ] })
      ] }),
      isMobile ? /* @__PURE__ */ jsx2(
        BottomSheet,
        {
          fullscreen: true,
          closeButton: true,
          sectionClassName: "p-4",
          stickyHeader: () => /* @__PURE__ */ jsx2("p", { className: "-mt-2 pb-4 text-center", children: t("subscription_common:upgrade") }),
          render: ({ open }) => /* @__PURE__ */ jsx2(RenderTrigger, { open, planInfo, event }),
          body: () => /* @__PURE__ */ jsx2(
            FirstAvailablePlan_default,
            {
              header: "",
              title: t("subscription_common:purchase_priority_upgrade"),
              planGroupId: planInfo.subscription_plan_group_id,
              onConfirm: (group, plan2) => {
                saveIntent();
                trackUpgradeEvent();
                push(`/${locale}/subscriptions/upgrade/${group._id}?current=${plan2._id}`);
              }
            }
          )
        }
      ) : /* @__PURE__ */ jsx2(
        Modal2,
        {
          closeButton: true,
          size: "xl",
          className: "p-6",
          render: ({ open }) => /* @__PURE__ */ jsx2(RenderTrigger, { open, planInfo, event }),
          body: () => /* @__PURE__ */ jsx2(
            FirstAvailablePlan_default,
            {
              className: "pb-20",
              planGroupId: planInfo.subscription_plan_group_id,
              title: t("subscription_common:purchase_priority_upgrade"),
              onPlanChange: (plan2) => {
                setPlan(plan2);
              }
            }
          ),
          stickyFooter: ({ close }) => /* @__PURE__ */ jsxs2("div", { className: "xs:flex-row xs:justify-end xs:gap-2 flex flex-col-reverse items-center gap-4 p-4", children: [
            /* @__PURE__ */ jsx2(Button2, { theme: "action", shape: "text", className: "xs:w-auto w-full", onClick: close, children: t("subscription_common:cancel") }),
            /* @__PURE__ */ jsx2(
              Button2,
              {
                theme: "action",
                as: Link,
                href: `/${locale}/subscriptions/upgrade/${planInfo.subscription_plan_group_id}?current=${(plan == null ? void 0 : plan._id) || ""}`,
                onClick: () => {
                  saveIntent();
                  trackUpgradeEvent();
                },
                "data-hidden": !planInfo.subscription_plan_group_id,
                className: "xs:w-auto w-full px-12 data-[hidden=true]:hidden",
                children: t("subscription_common:upgrade_and_continue")
              }
            )
          ] })
        }
      )
    ] })
  ] });
};
var RenderTrigger = ({ open, loading, planInfo, event }) => {
  const { t } = useTranslation2(["subscription_common"]);
  const { trackEvent } = useAnalytics();
  return /* @__PURE__ */ jsxs2(
    Button2,
    {
      className: "h-8 gap-2 px-4",
      onClick: () => {
        trackEvent({
          event: "clicked_on_upgrade_purchase_priority",
          data: { plan: planInfo.subscription_name, event_slug: event.slug }
        });
        open();
      },
      loading,
      children: [
        /* @__PURE__ */ jsx2(SubscriptionIcon, { className: "text-primary h-5 w-5 shrink-0" }),
        t("subscription_common:upgrade")
      ]
    }
  );
};
var Card_default = PriorityPlanCard;

// src/components/checks/priority/Check.tsx
import { Fragment as Fragment2, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var PurchasePriorityCheck = ({ children, event, prepend }) => {
  var _a, _b, _c, _d;
  const { active } = useSubscription();
  const { t } = useTranslation3("subscription_common");
  const [timeUp, isTimeUp] = useState3(false);
  const { subscriptions, isLoading, upgradablePlans, action } = useSubscriptionBenefits({
    event
  });
  const dateToBuy = useMemo(() => {
    var _a2, _b2;
    const startSaleDate = ((_a2 = event == null ? void 0 : event.start_selling_date) == null ? void 0 : _a2.date) ? (_b2 = parseDate(event.start_selling_date.date)) == null ? void 0 : _b2.getTime() : event.start_date_time * 1e3;
    return calculateDateToBuy({ startDate: startSaleDate, counter: action == null ? void 0 : action.counter });
  }, [(_a = event.start_selling_date) == null ? void 0 : _a.date, event.start_date_time, action == null ? void 0 : action.counter]);
  const upgradablePlansWithDate = useMemo(() => {
    const plans = upgradablePlans == null ? void 0 : upgradablePlans.map((plan) => {
      var _a2, _b2;
      const startSaleDate = ((_a2 = event == null ? void 0 : event.start_selling_date) == null ? void 0 : _a2.date) ? (_b2 = parseDate(event.start_selling_date.date)) == null ? void 0 : _b2.getTime() : event.start_date_time * 1e3;
      const dateToBuy2 = calculateDateToBuy({ startDate: startSaleDate, counter: plan.counter });
      return __spreadProps(__spreadValues({}, plan), { dateToBuy: dateToBuy2 });
    });
    return plans.sort((a, b) => b.value - a.value);
  }, [upgradablePlans, event.start_date_time, (_b = event == null ? void 0 : event.start_selling_date) == null ? void 0 : _b.date]);
  const hasPower = useMemo(() => {
    var _a2;
    const hasPriorityCheck = !!((_a2 = event.subscription_benefits) == null ? void 0 : _a2.purchase_priority);
    return !hasPriorityCheck || !(action == null ? void 0 : action.counter) || dateToBuy.getTime() < Date.now();
  }, [action == null ? void 0 : action.counter, (_c = event.subscription_benefits) == null ? void 0 : _c.purchase_priority, dateToBuy]);
  if (isLoading) {
    return /* @__PURE__ */ jsx3("section", { className: "flex min-h-[600px] items-center justify-center", children: /* @__PURE__ */ jsx3(Spinner, { className: "h-10 w-10" }) });
  }
  if (!active || timeUp || hasPower || !((_d = event == null ? void 0 : event.start_selling_date) == null ? void 0 : _d.date)) {
    return /* @__PURE__ */ jsxs3(Fragment2, { children: [
      /* @__PURE__ */ jsx3(Notice_default, {}),
      children
    ] });
  }
  return /* @__PURE__ */ jsxs3("section", { className: "flex min-h-[600px] flex-col items-center justify-center p-4", children: [
    /* @__PURE__ */ jsx3(Notice_default, {}),
    prepend,
    /* @__PURE__ */ jsxs3("div", { className: "mx-auto w-full max-w-xl space-y-6", children: [
      /* @__PURE__ */ jsx3("div", { className: "border-paper rounded-lg border p-6", children: /* @__PURE__ */ jsx3(Carousel, { options: { active: subscriptions.length > 1 }, children: subscriptions.map((subscription) => /* @__PURE__ */ jsx3(
        CurrentPlan,
        {
          subscription,
          dateToBuy,
          onTimeUp: () => isTimeUp(true),
          className: "basis-full"
        },
        subscription._id
      )) }) }),
      /* @__PURE__ */ jsx3("div", { className: "space-y-1", children: /* @__PURE__ */ jsx3(Typography2, { variant: "heading-M", children: t("subscription_common:get_early_access") }) }),
      /* @__PURE__ */ jsx3("div", { className: "space-y-4", children: upgradablePlansWithDate.map((plan) => {
        return /* @__PURE__ */ jsx3(Card_default, { event, planInfo: plan }, plan.subscription_plan_id);
      }) }),
      /* @__PURE__ */ jsxs3("div", { className: "space-y-2", children: [
        /* @__PURE__ */ jsx3(Typography2, { variant: "heading-S", children: t("subscription_common:note") }),
        /* @__PURE__ */ jsx3(Typography2, { children: t("subscription_common:priority_note") })
      ] })
    ] })
  ] });
};
var CurrentPlan = ({ subscription, dateToBuy, className, onTimeUp }) => {
  const { t } = useTranslation3("subscription_common");
  const NOW = useRef2(Date.now() / 1e3);
  const { isTimeUp, timer } = useCountDown2({
    id: subscription._id,
    initialSeconds: dateToBuy.getTime() / 1e3 - NOW.current
  });
  const name = subscription.plan.plan_group.name || subscription.plan.name;
  const hoursOfDays = isTimeUp ? 0 : timer.days * 24;
  const hours = isTimeUp ? 0 : hoursOfDays + timer.hours;
  const minutes = isTimeUp ? 0 : timer.minutes;
  const seconds = isTimeUp ? 0 : timer.seconds;
  useEffect2(() => {
    if (isTimeUp) {
      onTimeUp();
    }
  }, [isTimeUp]);
  return /* @__PURE__ */ jsxs3("div", { className: twMerge("shrink-0 space-y-2", className), children: [
    /* @__PURE__ */ jsxs3(Typography2, { as: "h2", variant: "heading-M", children: [
      t("subscription_common:your_current_plan"),
      ":"
    ] }),
    /* @__PURE__ */ jsxs3("div", { className: "flex items-center gap-2", children: [
      subscription.plan.icon && /* @__PURE__ */ jsx3("img", { src: subscription.plan.icon, className: "h-8 w-8", alt: name }),
      /* @__PURE__ */ jsx3("h2", { children: name })
    ] }),
    /* @__PURE__ */ jsx3("p", { className: "text-text-secondary", children: t("subscription_common:tickets_available_plan", { plan: name }) }),
    /* @__PURE__ */ jsxs3("div", { className: "flex items-center gap-2 pt-2", children: [
      /* @__PURE__ */ jsxs3("div", { className: "bg-text/10 grow rounded-lg p-4 text-center", children: [
        /* @__PURE__ */ jsx3("p", { className: "text-3xl font-bold", children: hours }),
        /* @__PURE__ */ jsx3("p", { className: "text-text-secondary font-light uppercase", children: t("subscription_common:hrs") })
      ] }),
      /* @__PURE__ */ jsxs3("div", { className: "bg-text/10 grow rounded-lg p-4 text-center", children: [
        /* @__PURE__ */ jsx3("p", { className: "text-3xl font-bold", children: minutes }),
        /* @__PURE__ */ jsx3("p", { className: "text-text-secondary font-light uppercase", children: t("subscription_common:mins") })
      ] }),
      /* @__PURE__ */ jsxs3("div", { className: "bg-text/10 grow rounded-lg p-4 text-center", children: [
        /* @__PURE__ */ jsx3("p", { className: "text-3xl font-bold", children: seconds }),
        /* @__PURE__ */ jsx3("p", { className: "text-text-secondary font-light uppercase", children: t("subscription_common:secs") })
      ] })
    ] })
  ] });
};

export {
  PurchasePriorityCheck
};
//# sourceMappingURL=chunk-FQGQL3DG.mjs.map